// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__PXNFd","devider":"styles_devider__1j3Wy"};